import React, { Component } from 'react'
import './Disclaimer.css'
import i18n from 'i18next'

export default class Disclaimer extends Component<any, any> {
  constructor(props: any) {
    super(props)
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.lang !== this.props.lang) {
      this.props.history.push('/disclaimer?lang=' + nextProps.lang + '&cc=' + nextProps.cc);
    }
  }

  render() {
    return (
      <div className="Disclaimer-Modal" style={{ fontSize: this.props.fontSize || "100%" }}>
        <div className="Modal-title">
          {i18n.t("Common.Disclaimer.Title2")}
        </div>
        <div className="content"
          dangerouslySetInnerHTML={{
            __html: i18n.t("Common.Disclaimer.Content2"),
          }}
        ></div>
        {/* <div className='body'>
          {i18n.t("Common.Disclaimer.Content2")}
        </div> */}
      </div>
    )
  }
}